import { render, staticRenderFns } from "./combineEdit.vue?vue&type=template&id=483783f2&scoped=true"
import script from "./combineEdit.vue?vue&type=script&lang=js"
export * from "./combineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483783f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('483783f2')) {
      api.createRecord('483783f2', component.options)
    } else {
      api.reload('483783f2', component.options)
    }
    module.hot.accept("./combineEdit.vue?vue&type=template&id=483783f2&scoped=true", function () {
      api.rerender('483783f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/devconfig/combineEdit.vue"
export default component.exports